<template>
  <div
    class="feature-block"
    :class="{ right: direction == 'right', left: direction == 'left' }"
  >
    <div class="feature-content">
      <h1>{{ content.title }}</h1>
      <hr />
      <p>
        {{ content.text }}
      </p>
      <Button v-if="content.button" :link="content.button.url" >{{ content.button.text }}</Button>
    </div>
    <div class="feature-image split">
      <img :src="content.image" />
    </div>
  </div>
</template>

<script>
import Button from "./Button.vue";
export default {
  name: "SplitColumn",
  components: {
    Button,
  },
  props: ["content", "direction"],
};
</script>

<style lang="scss" scoped>
@import "../styles/styles.scss";
h1 {
  letter-spacing: 1.3px;
}
p {
  text-align: left;
  padding: 0 0 1.5em 0;
}
hr {
  margin: 3.125em 0;
}
img {
  padding: 0.5em 0;
}
.feature-block {
  font-size: 0.58em;
  padding: 2em 0;
  .feature-content {
    flex-basis: 50%;
  }
  .feature-image {
    flex-basis: 50%;
  }
}

@include media(">=phone-md") {
  .feature-block {
    font-size: 1em;
  }
}

@include media(">=tablet") {
  .feature-block {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2em 0;
    padding: 0;
    .feature-content {
      padding-right: 2em;
      p {
        padding: 0 1em 0.5em 0;
      }
    }
  }
  .left {
    flex-direction: row;
    .feature-content {
      margin-right: 2em;
    }
    .feature-image {
      margin-left: 2em;
    }
  }
  .right {
    flex-direction: row-reverse;
    .feature-content {
      margin-left: 2em;
    }
    .feature-image {
      margin-right: 2em;
    }
  }
}
</style>